import classNames from 'classnames'

interface Props {
  className?: string
}

const ThickDivider = ({ className = '' }: Props) => {
  return <div className={classNames(className, 'border-t-1 w-full border-gray-200')} />
}

export default ThickDivider
